import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { defaultImagePlaceholder } from '../../../../../constants/images.constants';
import { IPropertyImage } from '../../../../../core/interfaces/property';

@Component({
  selector: 'app-booking-heading',
  templateUrl: './booking-heading.component.html',
  styleUrls: ['./booking-heading.component.scss'],
  standalone: false
})
export class BookingHeadingComponent implements OnInit {
  hiddenContent = true;
  imagePlaceholder = defaultImagePlaceholder;

  @Input() classList: string;
  @Input() isShowImage: boolean;
  @Input() dataFetched: boolean;
  @Input() name: string;
  @Input() streetAddress: string;
  @Input() bwImages: IPropertyImage[];
  @Output() isCollapsed: EventEmitter<boolean> = new EventEmitter();

  constructor() {}

  ngOnInit() {}

  openDetails() {
    this.hiddenContent = !this.hiddenContent;
    this.isCollapsed.emit(this.hiddenContent);
  }
}
